import clsApiPost from '@cls/clsApiPost'

// import clsRelationIncassoApi from '@/features/relation/incasso/api'; 

class clsRelationIncassoApi extends clsApiPost {

    send(model) { 
        return this.post(`send`, model); 
    }
    loadSendData(id_relation) { 
        return this.post(`loadsenddata`, {id_relation: id_relation}); 
    }    

    /**
     * 
     * @param {} formData 
     * @returns 
     */
    uploadAttachment(formData) {
        return this.upload(formData, 'attachment/upload');
    }

    /**
     * Remove an attachment
     */
    removeAttachment(id) {
        return this.post(`attachment/remove`, {id: id}); 
    }

    /**
     * download an attachment
     */
    async loadAttachment(id, bDownload) {
        if (bDownload) {
            return await this.downloadPost(`attachment/load`, {id: id});  
        }
        return await this.postRaw(`attachment/load`, {id: id});  
    }

}

export default clsRelationIncassoApi;
